import { Box, Typography } from "@mui/material";
import i18n from "i18next";
import { CSSProperties } from "react";
import { toast } from "react-toastify";
import iframeStore from "../pages/IframeNew/iframe-store.tsx";

const getToastStyle = (): CSSProperties => {
	return {
		width: "fit-content",
		background: "var(--white-color)",
		borderTop: `5px ${iframeStore?.iframe.config.custom_style?.cssVars?.["primary_main_color"] ?? "#8800ff"} solid`,
		boxShadow: "3px 3px 15px rgba(var(--black-color-rgb), 0.15)",
		color: "var(--text-primary-color)",
		textAlign: "left",
	};
};

const closeButton: JSX.Element = (
	<button
		className="Toastify__close-button Toastify__close-button--error"
		style={{ color: "var(--text-primary-color)" }}
		type="button"
		aria-label="close"
	>
		<svg aria-hidden="true" viewBox="0 0 14 16">
			<path
				fillRule="evenodd"
				d="M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
			></path>
		</svg>
	</button>
);

export function showErrorToast(errorMessage?: string, toastId?: string, errorHeader?: string): string | undefined {
	const taostId = toast.error(
		<Box>
			<Typography className="toastHeader">{errorHeader ?? i18n.t("ohSomethingWentWrong")}</Typography>
			<Typography className="toastMessage">{errorMessage ?? i18n.t("pleaseTryAgainLater")}</Typography>
		</Box>,
		{
			toastId,
			type: toast.TYPE.ERROR,
			autoClose: 10000,
			position: "bottom-left",
			style: getToastStyle(),
			closeButton,
		},
	);
	return taostId.toString();
}

export function showSuccessToast(
	successMessage?: string,
	toastId?: string,
	successHeader?: string,
): string | undefined {
	const taostId = toast.success(
		<Box>
			<Typography className="toastHeader">{successHeader ?? i18n.t("successHeader")}</Typography>
			<Typography className="toastMessage">
				{successMessage ?? i18n.t("yourActionCompletedSuccessfully")}
			</Typography>
		</Box>,
		{
			toastId,
			type: toast.TYPE.SUCCESS,
			autoClose: 10000,
			position: "bottom-left",
			style: getToastStyle(),
			closeButton,
		},
	);

	return taostId.toString();
}

export function showBottomCenterToast(message: string | React.ReactNode, toastId?: string): string | undefined {
	toast(message, {
		position: "bottom-center",
		autoClose: 5000,
		hideProgressBar: true,
		closeOnClick: true,
		className: "bottomCenterToast",
		toastId,
	});

	return toastId?.toString();
}
